const KATIN_BACKEND_API_URL = 'https://katin-backend-app.vercel.app/api';

//-- validate 
async function katin_ValidateEmail(email) {
  try {
    const response = await fetch(`${ KATIN_BACKEND_API_URL }/validate_email?email=${encodeURIComponent(email)}`);

    if (response.status === 200) {
      const data = await response.json();

      if (data.is_valid) {
        console.log("✅ Email is valid:", email);

        return true;        
      } else {
        console.log("❌ Email is invalid:", email);        

        return false;
      }
    } else {
      const errorData = await response.json();
      console.error("Error:", errorData.error);
    }

  } catch (err) {
    console.error("Request failed:", err);
  }

  return null;
}


//--------------------------------------------

//-- for user registration
document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('create_customer');

    if( form ){
      
      form.addEventListener('submit', async function (e) {      
        const emailField = form.querySelector('[name="customer[email]"]');
        const email = emailField.value.trim();
  
        // Prevent the default form submission
        e.preventDefault();
  
        const isValid = await katin_ValidateEmail(email);
  
        if (!isValid) {
          //alert('Please enter a valid email address.');
          emailField.focus();
          return;
        }
  
        // Email is valid — proceed with form submission
        form.submit();
      });
    }
});